module.exports = __webpack_public_path__ + "assets/img/transparency-3.9a4d842c.svg";